import './BaseSwiper.2a0a1be3e8fc2861f6b207afd9e72219.css';
export default {"swiperContainer":"_swiperContainer_o8o0i_1"};